export function clearBrowserStorage() {
    try {
        localStorage.clear()
    } catch {
        // noop
    }

    try {
        sessionStorage.clear()
    } catch {
        // noop
    }
}
